var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-aside',{attrs:{"width":"260px"}},[_c('search-form'),_vm._v(" "),_c('el-divider'),_vm._v(" "),_c('stock-tree')],1),_vm._v(" "),_c('el-container',[_c('el-header',[_c('nav-header')],1),_vm._v(" "),_c('el-main',[_c('daily-kline')],1),_vm._v(" "),_c('el-header',[_c('h2',[_vm._v("京ICP备2021016334号")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-469cd300","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainLayout.vue
// module id = null
// module chunks = 